import {
  Group,
  MediaQuery,
  Navbar,
  ScrollArea,
  Text,
  UnstyledButton,
  createStyles,
} from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useLogout from '../../../hooks/useLogout';
import { NavLinkType } from '../../../type/navlink.types';
import './sidebar.styles.css';
// import NavbarLinksGroup from "../components/navbar-links-group";
// import NavLink from "../components/nav-link";
import { Logout } from 'tabler-icons-react';
import useAuth from '../../../hooks/useAuth';
import NavLink from '../components/nav-link';
import NavLinkIcons from '../components/nav-links-icon';
import NavbarLinksGroup from '../components/navbar-links-group';
import NavbarLinksIconGroup from '../components/navbar-links-icon-group';
// import NavbarIconsLinksGroup from '../components/nav-link-icons';

// @ref https://ui.mantine.dev/category/navbars#navbar-segmented
const useStyles = createStyles((theme, _params, getRef) => {
  const icon = getRef('icon');

  return {
    navbar: {
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
    },

    title: {
      textTransform: 'uppercase',
      letterSpacing: -0.25,
    },

    link: {
      ...theme.fn.focusStyles(),
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      fontSize: theme.fontSizes.sm,
      color:
        theme.colorScheme === 'dark'
          ? theme.colors.dark[1]
          : theme.colors.gray[7],
      padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
      borderRadius: theme.radius.sm,
      fontWeight: 500,
      width: '100%',
      '&:hover': {
        backgroundColor:
          theme.colorScheme === 'dark'
            ? theme.colors.dark[6]
            : theme.colors.gray[0],
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,

        [`& .${icon}`]: {
          color: theme.colorScheme === 'dark' ? theme.white : theme.black,
        },
      },
    },

    version: {
      fontSize: theme.fontSizes.xs,
      color:
        theme.colorScheme === 'dark'
          ? theme.colors.dark[1]
          : theme.colors.gray[7],
    },

    linkIcon: {
      ref: icon,
      color:
        theme.colorScheme === 'dark'
          ? theme.colors.dark[2]
          : theme.colors.gray[6],
      marginRight: theme.spacing.sm,
    },

    linkActive: {
      '&, &:hover': {
        backgroundColor: theme.fn.variant({
          variant: 'light',
          color: theme.primaryColor,
        }).background,
        color: theme.fn.variant({ variant: 'light', color: theme.primaryColor })
          .color,
        [`& .${icon}`]: {
          color: theme.fn.variant({
            variant: 'light',
            color: theme.primaryColor,
          }).color,
        },
      },
    },
  };
});

interface AppSidebarProps {
  opened: boolean;
  navLinkProps: NavLinkType[];
  hideSidebar?: boolean;
}

const AppSidebar = (props: AppSidebarProps) => {
  const { opened, navLinkProps } = props;
  const logout = useLogout();
  const { pathname } = useLocation();
  const defaultActiveLabel = props.navLinkProps[0].label;
  const [active, setActive] = useState(defaultActiveLabel);
  const { auth } = useAuth();
  const [openSidebar, setOpenSidebar] = useState<boolean>(opened);

  const { classes, cx } = useStyles();

  useEffect(() => {
    let activeLabel = defaultActiveLabel;

    for (let i = 0; i < navLinkProps.length; i++) {
      if (navLinkProps[i].sublinks) {
        let found = false;

        for (let j = 0; j < navLinkProps[i].sublinks!.length; j++) {
          const sublink = navLinkProps[i].sublinks![j].link;
          if (
            //TODO find better way to handle, this is a temp fix
            pathname
              .slice(pathname.length - sublink.length, pathname.length)
              .includes(sublink)
          ) {
            activeLabel = navLinkProps[i].sublinks![j].label;
            found = true;
            break;
          }
        }
        if (found) {
          break;
        }
      } else {
        if (pathname.includes(navLinkProps[i].link)) {
          activeLabel = navLinkProps[i].label;
        }
      }
    }
    setActive(activeLabel);
  }, [pathname]);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Navbar
      p="md"
      hiddenBreakpoint="md"
      hidden={!opened}
      width={opened ? { sm: 220, lg: 220 } : { sm: 92.5, lg: 92.5 }}
      className={`sidebar ${props.hideSidebar ? 'hidden' : ''}`}
    >
      <Navbar.Section grow component={ScrollArea}>
        <Group direction="column" grow spacing="sm">
          {navLinkProps.map((value, index) => {
            const component = value.sublinks ? (
              opened || openSidebar ? (
                <NavbarLinksGroup
                  icon={value.icon}
                  key={index}
                  label={value.label}
                  sublinks={value.sublinks}
                  active={active}
                  setActive={setActive}
                />
              ) : (
                <NavbarLinksIconGroup
                  icon={value.icon}
                  key={index}
                  sublinks={value.sublinks}
                  active={active}
                  setActive={setActive}
                />
              )
            ) : opened ? (
              <NavLink
                href={value.link}
                key={index}
                value={value}
                active={active}
                setActive={setActive}
              >
                {value.label}
              </NavLink>
            ) : (
              <NavLinkIcons
                href={value.link}
                key={index}
                value={value}
                active={active}
                setActive={setActive}
              />
            );

            return component;
          })}

          <MediaQuery largerThan="md" styles={{ display: 'none' }}>
            <UnstyledButton className={classes.link} onClick={handleLogout}>
              <Logout className={classes.linkIcon} strokeWidth={1.5} />
              <span style={{ fontSize: 16 }}>Logout</span>
            </UnstyledButton>
          </MediaQuery>
        </Group>
      </Navbar.Section>

      {/* {auth?.role === Roles.ADMINISTRATOR && ( */}
      <Navbar.Section>
        <Text className={classes.version} align="center">
          Version 7.70.2
        </Text>
      </Navbar.Section>
      {/* )} */}
    </Navbar>
  );
};

export default AppSidebar;
